import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changePrice: (value: Nullable<number>) => void;
	isDisabled: boolean;
}

export const PriceInput: React.FC<IProps> = React.memo(({ changePrice, isDisabled }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPrice') }], [t]);

	return (
		<FormInput
			testId="PriceInput"
			name="price"
			label="signedPriceLabel"
			min={0}
			precision={0}
			disabled={isDisabled}
			onChangeNumber={changePrice}
			validationRules={validationRules}
			type="number"
		/>
	);
});
